<template lang="html">
  <div class="spinner-container">
    <van-loading class="spinner-progress" color="black" />
    <span class="spinner-text">{{$t("tips.loading")}}...</span>
  </div>
</template>

<script>
export default {
  name: "loadingSpinner",
  props: {
    complete: {
      default: false
    },
    noData: {
      default: false
    }
  }
};
</script>

<style lang="scss">
.spinner-container{
  padding: .1rem 0;
  text-align: center;
  .spinner-progress{
    display: inline-block;
    vertical-align: middle;
  }
  .spinner-text{
    margin-left: 8px;
    font-size: 14px;
    color: #a9a6a6;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/loadingSpinner.vue